<template>
  <div>
    <el-card style="margin-bottom: 20px">
      <el-form :model="query" inline>
        <el-form-item label="关键词">
          <el-input v-model="query.keyword" placeholder="请输入关键词" clearable></el-input>
        </el-form-item>
        <el-form-item label="城市">
          <el-select v-model="query.cityCode" placeholder="全部城市" clearable filterable>
            <el-option label="全局" value=""></el-option>
            <el-option
              v-for="item in cityOptions"
              :key="item.cityCode"
              :label="item.cityName"
              :value="item.cityCode"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.enabled" placeholder="全部状态" clearable>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card>
      <div style="margin-bottom: 15px">
        <el-button type="primary" @click="handleAdd">新增热搜词</el-button>
      </div>
      <el-table :data="list" border stripe v-loading="loading">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="keyword" label="关键词" min-width="160"></el-table-column>
        <el-table-column label="城市" min-width="140">
          <template slot-scope="{ row }">
            {{ formatCity(row.cityCode) }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90">
          <template slot-scope="{ row }">
            <el-tag :type="row.enabled === 1 ? 'success' : 'info'" size="small">
              {{ row.enabled === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sortOrder" label="排序" width="80"></el-table-column>
        <el-table-column prop="searchCount" label="搜索次数" width="100"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleEdit(row)">编辑</el-button>
            <el-button type="text" @click="handleToggle(row)">{{ row.enabled === 1 ? '禁用' : '启用' }}</el-button>
            <el-button type="text" style="color: #F56C6C" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 20px; text-align: right"
        :current-page="query.pageNum"
        :page-sizes="[10, 20, 50]"
        :page-size="query.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next"
        @size-change="val => { query.pageSize = val; fetchList() }"
        @current-change="val => { query.pageNum = val; fetchList() }"
      ></el-pagination>
    </el-card>

    <el-dialog :title="isEdit ? '编辑热搜词' : '新增热搜词'" :visible.sync="dialogVisible" width="520px">
      <el-form ref="form" :model="form" :rules="rules" label-width="90px">
        <el-form-item label="关键词" prop="keyword">
          <el-input v-model="form.keyword" placeholder="请输入热搜词"></el-input>
        </el-form-item>
        <el-form-item label="适用城市" prop="cityCode">
          <el-select v-model="form.cityCode" placeholder="选择全局或城市" clearable filterable style="width: 100%">
            <el-option label="全局" value=""></el-option>
            <el-option
              v-for="item in cityOptions"
              :key="item.cityCode"
              :label="item.cityName"
              :value="item.cityCode"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch
            v-model="form.enabled"
            :active-value="1"
            :inactive-value="0"
            active-text="启用"
            inactive-text="禁用"
          ></el-switch>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sortOrder" :min="0"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCities, getHotKeywords, addHotKeyword, updateHotKeyword, deleteHotKeyword } from '../../api'

export default {
  name: 'HotSearchManage',
  data() {
    return {
      query: { keyword: '', cityCode: '', enabled: '', pageNum: 1, pageSize: 10 },
      cityOptions: [],
      list: [],
      total: 0,
      loading: false,
      dialogVisible: false,
      isEdit: false,
      form: { id: null, keyword: '', cityCode: '', enabled: 1, sortOrder: 0 },
      rules: {
        keyword: [{ required: true, message: '请输入热搜词', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.fetchCities()
    this.fetchList()
  },
  methods: {
    fetchCities() {
      getCities({ page: 1, pageSize: 500 }).then(res => {
        this.cityOptions = res.data.records || res.data || []
      }).catch(() => {
        this.cityOptions = []
      })
    },
    fetchList() {
      this.loading = true
      getHotKeywords(this.query).then(res => {
        this.list = res.data.records || res.data || []
        this.total = res.data.total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    search() {
      this.query.pageNum = 1
      this.fetchList()
    },
    reset() {
      this.query = { keyword: '', cityCode: '', enabled: '', pageNum: 1, pageSize: 10 }
      this.fetchList()
    },
    handleAdd() {
      this.isEdit = false
      this.form = { id: null, keyword: '', cityCode: '', enabled: 1, sortOrder: 0 }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
    },
    handleEdit(row) {
      this.isEdit = true
      this.form = {
        id: row.id,
        keyword: row.keyword || '',
        cityCode: row.cityCode || '',
        enabled: row.enabled === undefined ? 1 : row.enabled,
        sortOrder: row.sortOrder || 0
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const payload = { ...this.form, cityCode: this.form.cityCode || null }
        const fn = this.isEdit ? updateHotKeyword(this.form.id, payload) : addHotKeyword(payload)
        fn.then(() => {
          this.$message.success(this.isEdit ? '修改成功' : '新增成功')
          this.dialogVisible = false
          this.fetchList()
        })
      })
    },
    handleToggle(row) {
      const nextEnabled = row.enabled === 1 ? 0 : 1
      updateHotKeyword(row.id, {
        keyword: row.keyword,
        cityCode: row.cityCode || null,
        enabled: nextEnabled,
        sortOrder: row.sortOrder
      }).then(() => {
        this.$message.success(nextEnabled === 1 ? '已启用' : '已禁用')
        this.fetchList()
      })
    },
    handleDelete(row) {
      this.$confirm('确定要删除该热搜词吗？', '提示', { type: 'warning' }).then(() => {
        deleteHotKeyword(row.id).then(() => {
          this.$message.success('删除成功')
          this.fetchList()
        })
      }).catch(() => {})
    },
    formatCity(cityCode) {
      if (!cityCode) return '全局'
      const city = this.cityOptions.find(item => item.cityCode === cityCode)
      return city ? city.cityName : cityCode
    }
  }
}
</script>
